// FLOW Platform — thruWord: How to play as a practice round (2.14.37).
//
// Jeff, 2026-10-13: "How to play for Hive, Word², OneOff and thruWord, each as a short practice round like WordAGE's
// ... with "Don't show this again" on every step, a Settings switch and the ? button, as in WordAGE." The sheet, Back,
// Next and Skip, the pointer and the switch are the platform's (assets/shared/flow-howto-v1.js, enqueued by the
// shortcode); this module DECLARES thruWord's four steps and its practice puzzle. Jeff, 2026-10-15: "you can also
// consolidate the first three screens".

/* THRUWORD: HOW TO PLAY AS A PRACTICE ROUND (2.14.37). A practice puzzle of its own, HOUSE to SHOE through WORK and HORSE
   (housework, workhorse, horseshoe): the only way across in the game's own compound list, and no daily uses it (checked
   against all 1,185 chains). Played through the real game before a line was written: BOAT is refused with "HOUSEBOAT is a
   real compound, but it leads to a dead end. Try another word.", its O stays in place in green and B, A and T go grey on
   the keyboard; W, R and K typed round the O lock "✓ HOUSEWORK"; the Letter hint shows the H of HORSE, and its box then
   reads "Show answers"; the end reads "Solved · 3 guesses · 1/1 hints". */
export const THRUWORD_HOW = (function () {
  var TOP = 'HOUSE', END = 'SHOE', ANS = ['WORK', 'HORSE'];
  function S0(o) { var s = { slots: ['', ''], locked: [false, false], active: 0, pinned: [{}, {}], grey: '', toast: '', tk: '', btn: '', hint: 0, done: false }; for (var k in o) s[k] = o[k]; return s; }
  function slot(S, i) {
    var n = ANS[i].length, typed = S.slots[i].split(''), cells = '';
    if (S.locked[i]) return '<div class="twRow ok">' + ANS[i] + '</div>';
    var t = 0;
    for (var k = 0; k < n; k++) {
      var pin = S.pinned[i][k];
      if (pin) cells += '<span class="twBox green">' + pin + '</span>';
      else { var ch = typed[t++] || ''; cells += '<span class="twBox' + (ch ? ' typed' : '') + '">' + ch + '</span>'; }
    }
    return '<div class="twRow ' + (S.active === i ? 'active' : 'wait') + '">' + cells + '</div>';
  }
  function keys(S, H) {
    var rows = ['QWERTYUIOP', 'ASDFGHJKL', 'ZXCVBNM'];
    return '<div class="twPad">' + rows.map(function (r, ri) {
      var ks = r.split('').map(function (c) { return '<span class="twKey' + (S.grey.indexOf(c) > -1 ? ' grey' : '') + '" data-key="' + c + '">' + c + '</span>'; }).join('');
      if (ri === 2) ks = '<span class="twKey wide">⌫</span>' + ks + '<span class="twKey wide' + H.go(S.btn === 'enter') + '" data-key="enter">Enter' + (S.btn === 'enter' ? H.pin() : '') + '</span>';
      return '<div class="twKr">' + ks + '</div>';
    }).join('') + '</div>';
  }
  function hint(S, H) {
    return '<div class="twHint"><span class="lab">Hint</span><span class="twHintBox' + (S.hint ? ' used' : '') + H.go(S.btn === 'hint') + '" data-key="hint">' +
      (S.hint ? 'Show answers' : 'Letter') + (S.btn === 'hint' ? H.pin() : '') + '</span><span class="twUsed"><b>' + S.hint + '/1</b> used</span></div>';
  }
  function endPic() {
    return '<div class="twEnd"><div class="twEndHead">Excellent!</div><div class="twEndSum">Solved · 3 guesses · 1/1 hints</div></div>' +
      '<div class="twChain">' + [TOP, 'WORK', 'HORSE', END].map(function (w, i, a) {
        return '<div class="twRow done">' + w + '</div>' + (i < a.length - 1 ? '<div class="twJoin">' + w + a[i + 1] + '</div>' : ''); }).join('') + '</div>';
  }
  function pic(S, H) {
    if (S.done) return endPic();
    return '<div class="twRow end">' + TOP + '</div><div class="twArrow">↓</div>' + slot(S, 0) + '<div class="twArrow">↓</div>' + slot(S, 1) +
      '<div class="twArrow">↓</div><div class="twRow end">' + END + '</div>' + hint(S, H) +
      '<div class="fhToast ' + (S.tk || '') + '">' + (S.toast || '&nbsp;') + '</div>' + keys(S, H);
  }
  async function type(H, tok, S, letters, enter, result) {
    for (var i = 0; i < letters.length; i++) {
      var c = letters[i];
      if (!(await H.press(tok, '[data-key="' + c + '"]', function () { S.slots[S.active] += c; S.toast = ''; H.paint(S); }, 420))) return false;
    }
    if (enter && !(await H.press(tok, '[data-key="enter"]', function () { result(S); H.paint(S); }, 520))) return false;
    return true;
  }
  function loop(start, play) {
    return async function (H, tok) {
      H.ptrShow(null, true); H.rest();
      while (H.alive(tok)) {
        var S = start(); H.paint(S); H.rest();
        await H.sleep(700); if (!H.alive(tok)) return;
        if (!(await play(H, tok, S))) return;
        await H.sleep(2200);
      }
    };
  }
  var DEAD = 'HOUSEBOAT is a real compound, but it leads to a dead end. Try another word.';
  var afterBoat = function () { return S0({ pinned: [{ 1: 'O' }, {}], grey: 'BAT', toast: DEAD, tk: 'bad' }); };
  var afterWork = function () { var S = S0({ locked: [true, false], active: 1, grey: 'BAT', toast: '✓ HOUSEWORK', tk: 'good' }); return S; };
  var afterHint = function () { var S = afterWork(); S.pinned = [{}, { 0: 'H' }]; S.hint = 1; S.toast = ''; return S; };
  var solvedS = function () { var S = afterHint(); S.locked = [true, true]; S.toast = '✓ WORKHORSE'; S.tk = 'good'; return S; };
  var STEPS = [
    { title: function () { return 'An example puzzle'; },
      line: function () { return 'Get from the top word to the bottom word. Each word you type must make a compound word with the word above it and the word below it. HOUSEBOAT is a compound word, so try BOAT.'; },
      start: function () { return S0({}); }, end: afterBoat, pic: pic,
      anim: loop(function () { return S0({}); }, function (H, tok, S) {
        return type(H, tok, S, 'BOAT', true, function (S) { var a = afterBoat(); for (var k in a) S[k] = a[k]; }); }) },
    { title: function () { return 'Read the colors'; },
      line: function () { return 'BOAT is a dead end, because no word fits between BOAT and SHOE. Its O is in the right place, so the O stays, in green. Grey keys are letters the word does not have. Type W, R and K around the O, and HOUSEWORK is accepted.'; },
      start: afterBoat, end: afterWork, pic: pic,
      anim: loop(function () { var S = afterBoat(); S.toast = ''; return S; }, function (H, tok, S) {
        return type(H, tok, S, 'WRK', true, function (S) { var a = afterWork(); for (var k in a) S[k] = a[k]; }); }) },
    { title: function () { return 'Stuck? Take the hint'; },
      line: function (H) { return 'Each puzzle has one Letter hint. ' + H.verb() + ' Letter.'; },
      start: function () { var S = afterWork(); S.toast = ''; S.btn = 'hint'; return S; }, pic: pic,
      after: { line: function () { return 'The hint shows the next letter of the word you are on. Once it is used, its box offers Show answers, which ends the puzzle and shows the words.'; },
               state: afterHint } },
    { title: function () { return 'Finish the chain'; },
      line: function () { return 'HORSE makes WORKHORSE with the word above it and HORSESHOE with the word below it, so the puzzle is solved. Any word that makes both compounds counts. Solving without the hint is the better result.'; },
      start: afterHint, end: function () { return S0({ done: true }); }, pic: pic,
      anim: loop(afterHint, async function (H, tok, S) {
        if (!(await type(H, tok, S, 'ORSE', true, function (S) { var a = solvedS(); for (var k in a) S[k] = a[k]; }))) return false;
        await H.sleep(1100); if (!H.alive(tok)) return false;
        H.ptrHide(); S.done = true; H.paint(S); await H.sleep(2800); if (!H.alive(tok)) return false; H.ptrShow(null, true); H.rest(); return true; }),
      last: true }
  ];
  var CSS = [
    '.flow-how .twRow{width:86%;margin:0 auto;border:1px solid #8E8574;background:#E7DFCF;border-radius:10px;height:38px;display:flex;align-items:center;justify-content:center;gap:4px;',
    '  font-family:var(--flow-display);font-weight:700;font-size:17px;letter-spacing:.06em}',
    '.flow-how .twRow.active{border:2px solid var(--fht-accent-deep,#9A3B26);background:var(--flow-surface)}',
    '.flow-how .twRow.wait{border:1px dashed #B5AB98;background:transparent}',
    '.flow-how .twRow.ok{background:#D8E8CF;border-color:#5C9E4A}',
    '.flow-how .twRow.done{background:var(--flow-surface);height:32px;font-size:15px}',
    '.flow-how .twBox{width:24px;height:27px;border:1px solid #C9BFAD;border-radius:5px;display:grid;place-items:center;font-size:14px;background:transparent}',
    '.flow-how .twBox.typed{background:#E7DFCF}.flow-how .twBox.green{background:#3E9E4E;border-color:#3E9E4E;color:#fff}',
    '.flow-how .twArrow{text-align:center;color:var(--flow-faint,#A69E90);font-size:12px;line-height:1;margin:-3px 0}',
    '.flow-how .twHint{display:flex;justify-content:center;align-items:center;gap:9px;font-size:11px;color:var(--flow-muted);letter-spacing:.06em;text-transform:uppercase;margin-top:2px}',
    '.flow-how .twHintBox{position:relative;text-transform:none;letter-spacing:0;font:700 13px/1 var(--flow-sans);color:var(--flow-ink);background:var(--flow-surface);border:1px solid var(--flow-line);border-radius:10px;padding:9px 16px}',
    '.flow-how .twHintBox.used{border-style:dashed;color:var(--flow-muted)}.flow-how .twUsed b{font-size:13px;color:var(--flow-ink);letter-spacing:0}',
    '.flow-how .twPad{display:flex;flex-direction:column;gap:4px}.flow-how .twKr{display:flex;gap:3px;justify-content:center}',
    '.flow-how .twKey{position:relative;flex:1 1 0;max-width:27px;height:32px;border-radius:4px;background:#DFD5C3;display:grid;place-items:center;font:700 12px/1 var(--flow-sans)}',
    '.flow-how .twKey.grey{background:#A39A8A;color:#fff}.flow-how .twKey.wide{flex:1.6 1 0;max-width:46px;font-size:11px}',
    '.flow-how .twEnd{background:#D8E8CF;border:2px solid #5C9E4A;border-radius:12px;padding:12px;text-align:center}',
    '.flow-how .twEndHead{font-family:var(--flow-display);font-weight:700;font-size:23px}.flow-how .twEndSum{font-size:13.5px;font-weight:600;margin-top:3px}',
    '.flow-how .twChain{display:flex;flex-direction:column;gap:3px;margin-top:6px}',
    '.flow-how .twJoin{text-align:center;font-size:10.5px;letter-spacing:.1em;color:var(--flow-faint,#A69E90)}'
  ].join('\n');
  return { steps: STEPS, css: CSS };
})();

/* the practice in thruWord's own colours: the platform's frame reads --flow-accent, thruWord's accent is --fht-accent */
const CSS_ACCENT = '#flowHow-thruword{--flow-accent:var(--fht-accent,#BD5036);--flow-accent-deep:#9A3B26;--flow-accent-soft:var(--fht-accent-soft,#F0D9D2)}';

const KEY = 'flow_fht_howto_v1';
let ctl = null;
let ctx = { button: null, rules: null, puzzle: () => null, fresh: () => false };

/** Attach the practice once the platform's frame is on the page. False while it is not (it may never be). */
export function armHow() {
  if (ctl) return true;
  if (!window.flowHowto) return false;
  ctl = window.flowHowto.attach({
    game: 'thruword', key: KEY, noun: 'puzzle', steps: THRUWORD_HOW.steps, css: THRUWORD_HOW.css + '\n' + CSS_ACCENT,
    rules: () => (ctx.rules ? ctx.rules() : ''),
    button: ctx.button,
    puzzle: () => ctx.puzzle(),
    fresh: () => ctx.fresh(),
  });
  return true;
}
export function setHowContext(c) { ctx = Object.assign(ctx, c || {}); }
export function howCtl() { return armHow() ? ctl : null; }
/** ? : the practice, or (if the frame never arrived) false so the caller opens the written rules. */
export function openHow() { if (!armHow()) return false; ctl.open('button'); return true; }
/** a puzzle has come up: the practice opens by itself if nobody has played it yet */
export function autoHow() { if (armHow()) ctl.auto(); }
export const HOW_SETTINGS = { label: 'Show How to play when I start a puzzle', sub: 'You can always open it with the ? button.' };
